import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

const TypedText = ({
  strings,
  options = {},
  loop = true,
  delay = 500,
  style,
}) => {
  const typedRef = useRef(null);

  useEffect(() => {
    if (!typedRef.current) return;

    const typed = new Typed(typedRef.current, {
      strings,
      loop,
      typeSpeed: 50, // Adjust speed for desired delay
      cursorChar: "|", // Use a pipe character as the cursor
      backDelay: 2000, // Optional delay before backspacing
      ...options, // Apply any custom options you want
    });

    return () => {
      typed.destroy(); // Clean up the Typed instance on unmount
    };
  }, [strings, options, loop, delay]); // Rerun useEffect when necessary

  return <span style={style} ref={typedRef} />;
};

export default TypedText;
